import * as React from 'react';
import {LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';

export interface ReopenApplicationConfirmProps {
    onPressConfirm: () => void;
    onPressClose: () => void;
}

const ReopenApplicationConfirmView: React.FC<ReopenApplicationConfirmProps> = ({onPressConfirm, onPressClose}) => (
    <div className="col-12 p-0">
        <div className="text-justify">
            <p>{LOAN_APPLICATION_MX.REOPEN_CONFIRM_MESSAGE}</p>
        </div>
        <div className="pt-3 px-0 text-right border-top">
            <button type="button" className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
                    onClick={onPressClose}>{LOAN_APPLICATION_MX.CANCEL_BUTTON}</button>
            <button type="button" className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
                    onClick={onPressConfirm}>{LOAN_APPLICATION_MX.ACCEPT_BUTTON}</button>
        </div>
    </div>
);

export default ReopenApplicationConfirmView;
